import { type Step } from '.';

export const findNextEnabledStep = (startIndex: number, steps: Step[], skip = 1): number | undefined => {
  const index = startIndex + skip;
  const next = steps[index];

  if (!next) {
    return undefined;
  }

  if (next.enabled) {
    return index;
  }

  return findNextEnabledStep(index, steps);
};

export const findPreviousEnabledStep = (startIndex: number, steps: Step[], skip = 1): number | undefined => {
  const index = startIndex - skip;
  const previous = steps[index];

  if (!previous) {
    return undefined;
  }

  if (!previous.returnable) {
    return findPreviousEnabledStep(index, steps);
  }

  if (previous.enabled) {
    return index;
  }

  return findPreviousEnabledStep(index, steps);
};

export const normalizeSteps = (steps: Step[]) =>
  steps.map(step => {
    return {
      enabled: step.enabled ?? true,
      merge: step.merge ?? false,
      scroll: step.scroll ?? true,
      returnable: step.returnable ?? true,
      ...step
    };
  });
